<template lang="pug">
  div
        h2 Welcome to Maragusan Multipurpose Cooperative (Online/Mobile) Membership System
        p Please see below the checklists to become a member before you proceed to the next step .

        p Check list of membership:


        ul#pills-tab.nav.nav-pills.mb-3.nav-justified(role='tablist')
            li.nav-item(v-for="(membership, index) in memberships")
                a#pills-home-tab.nav-link(:class="{'active': index==0}" data-toggle='pill', :href="'#membership-'+membership.id" role='tab' aria-controls='pills-home' aria-selected='true') Membership {{index+1}}
        #pills-tabContent.tab-content
            .tab-pane.fade(v-for="(membership, index) in memberships", :id="'membership-'+membership.id", :class="{'show': index==0, 'active': index==0}" role='tabpanel' aria-labelledby='pills-home-tab')
                .card
                    .card-body
                        h5.card-title {{membership.name}}
                        p.card-text {{membership.description}}

                    ul.list-group.list-group-flush(v-if="membership.qualifications.length > 0")
                        li.list-group-item.list-group-item-secondary
                            span: b Qualification
                        li.list-group-item(v-for="(qualification, i) in membership.qualifications", :key="'qualification-'+qualification.id")
                            span {{qualification.name}}
                    ul.list-group.list-group-flush(v-if="membership.monetaries.length > 0")
                        li.list-group-item.list-group-item-secondary
                            span: b Monetary
                        li.list-group-item(v-for="(monetary, i) in membership.monetaries", :key="'monetary-'+monetary.id")
                            span {{monetary.name}}
                    ul.list-group.list-group-flush(v-if="membership.documentaries.length > 0")
                        li.list-group-item.list-group-item-secondary
                            span: b Documentary
                        li.list-group-item(v-for="(documentary, i) in membership.documentaries", :key="'documentary-'+documentary.id")
                            span {{documentary.name}}

                    ul.list-group.list-group-flush(v-if="membership.service_fees.length > 0")
                        li.list-group-item.list-group-item-secondary
                            span: b Service Fee
                        li.list-group-item.d-flex.justify-content-between(v-for="(service, i) in membership.service_fees", :key="'service-'+service.id")
                            span {{service.name}}
                            span PHP {{service.price}}
                        li.list-group-item.d-flex.justify-content-between
                            span: b TOTAL
                            span: b PHP {{ membership.total_fee }}
                    ul.list-group.list-group-flush(v-else="")
                        li.list-group-item.text-center
                            span: i ( No services )

        p Please also ensure that the mobile number and email address you provided is the current number and email address actually used by the applicant.
        p Applicant for all notices on his application as well as future notices from Magrow MPC once accepted for membership.
</template>

<style scoped=""></style>

<script>
// import { ref, reactive, onMounted } from '@vue/composition-api';

export default {
  name: 'Welcome',
  props: {
    memberships: {
      type: Array,
      required: true,
    },
  },

  setup(_props, { _emit }) {
    // eslint-disable-line no-unused-vars
    return {};
  },
};
</script>
